import { FC, useCallback, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { Input, InputGroup, InputLeftElement, ModalHeader, SearchOutline } from '@bonusly/design-system';

import { useKeyboardTrigger } from '../../hooks/use-keyboard-trigger';
import { InputControls } from './InputControls';

interface SearchHeaderProps {
	onChange: (value: string) => void;
	onClose: VoidFunction;
	value: string;
}

export const SearchHeader: FC<SearchHeaderProps> = ({ onChange, onClose, value }) => {
	const inputRef = useRef<HTMLInputElement>(null);
	const { t } = useTranslation('navigation');

	const onClearValue = () => onChange('');

	const onFocus = useCallback(() => {
		inputRef.current?.focus();
	}, []);

	useKeyboardTrigger('k', onFocus, { meta: true });

	return (
		<ModalHeader display="flex" p={2}>
			<InputGroup>
				<InputLeftElement>
					<SearchOutline size="md" />
				</InputLeftElement>

				<Input
					border="none"
					_focus={{ boxShadow: 'none' }}
					onChange={({ target: { value } }) => onChange(value)}
					placeholder={t('search.input_placeholder')}
					ref={inputRef}
					type="text"
					value={value}
				/>
			</InputGroup>

			<InputControls onClearValue={onClearValue} onClose={onClose} value={value} />
		</ModalHeader>
	);
};
